import React from "react";
import { Button, Modal } from "react-bootstrap";
import Resources from "../../types/Resources";
import useDeleteCompanyModal from "./useDeleteCompanyModal";
import LoadingSpinner from "../Common/LoadingSpinner";

export type DeleteCompanyModalProps = {
    resources: Resources;
    show: boolean;
    companyId: string;
    onHide: () => void;
    onCompanyDeleted: () => void;
};

function DeleteCompanyModal(props: DeleteCompanyModalProps) {
    const { resources } = props;

    const modelContent = useDeleteCompanyModal(props);

    return (
        <Modal show={props.show} onHide={props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{resources.get("DeleteCompany")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {modelContent.isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <>
                        <p>{resources.get("ConfirmDeleteFollowingCompany")}</p>
                        <p>
                            <strong>{modelContent.company?.name}</strong>
                        </p>
                        <div className="mt-3 w-100 d-flex justify-content-evenly gap-3">
                            <Button
                                variant="danger"
                                onClick={modelContent.handleDeleteCompanyAsync}
                                disabled={modelContent.deleteInProgress}
                                className="w-100"
                            >
                                {resources.get("YesDeleteCompany")}
                            </Button>
                            <Button
                                variant="secondary"
                                onClick={props.onHide}
                                disabled={modelContent.deleteInProgress}
                                className="w-100"
                            >
                                {resources.get("Cancel")}
                            </Button>
                        </div>
                    </>
                )}
            </Modal.Body>
        </Modal>
    );
}

export default DeleteCompanyModal;
